/**
 * Returns true if string contain only number
 */

const isNumber = (string: string): boolean => {
  const regexNumber = /^\d*$/
  if (string) {
    return regexNumber.test(string)
  }
  return false
}

export default isNumber
